import {Component, OnInit, ViewChild} from '@angular/core';
import {QARService, SORUserEntity, SystemRoleEntity} from '../services/qar.service';
import {UIInputAutocompleterComponent} from '../framework/ui/input-autocompleter';
import { map, Observable } from 'rxjs';

@Component({
	selector: 'app-page-sod-checker',
	templateUrl: './sod-checker.html',
	providers: [QARService]
})
export class SODCheckerPageComponent implements OnInit {
     

	@ViewChild('autocompleterUsers', {static: true}) autocompleterUsers: UIInputAutocompleterComponent;
	@ViewChild('autocompleterRoles', {static: true}) autocompleterRoles: UIInputAutocompleterComponent;
    selectedRoles:any[]=[];
	public self = this;
	activeTab = 'clash'; // Default tab
    sodClashRoleList:Observable<SystemRoleEntity[]>;
	sodClashUserList:Observable<SORUserEntity[]>;
	 sodcheckReponse:any[]=[]; 
	 selectedRoleList:any[]=[];
	constructor(public api: QARService) {
	}
     
	ngOnInit(): void {
    this.sodClashUserList= this.api.searchSORUser('');
	this.sodClashRoleList=this.api.searchSystemRole('');		
	}

	public search_sor_users(search):Observable<SORUserEntity[]> {
		return  this.sodClashUserList.pipe(
			map(users=>users.filter(user=>
			(user.Login?.toLowerCase()??'').includes(search.toLowerCase()) ||
			(user.FirstName?.toLowerCase()??'').includes(search.toLowerCase()) ||
			(user.LastName?.toLowerCase()??'').includes(search.toLowerCase()) ||
			(`${user.FirstName ?? ''} ${user.LastName ?? ''}`.toLowerCase()).includes(search.toLowerCase())
			))
		);
	}

	public search_roles(search): Observable<SystemRoleEntity[]> {
		  return this.sodClashRoleList.pipe(
             map(roles => roles.filter(role => 
				(role.Name?.toLowerCase()??'')
				.includes(search.toLowerCase()) ||
				(role.System.Name?.toLowerCase()??'')
				.includes(search.toLowerCase()) ||
				(role.MappedName?.toLowerCase()??'')
				.includes(search.toLowerCase())
			)));
	}

	public sodcheck = {
		user: null,
		role: null,
		loading: false,
		clash: false,
		valid: false,
		clashWith: [],
		userAsText: null,
		roleAsText: null
	};
   
	public sodcheck_doCheck() {
	
		const user = this.autocompleterUsers.formControl.value;		
		if (!user) {
			alert('Please fill in the user name');
		} else if (this.selectedRoles.length==0) {
			alert('Please fill in the role name');
		} 
		else 
		{
			const role =this.selectedRoles.map(item=>item.Id);
			this.activeTab = 'clash'; 
			this.sodcheck.loading = true;
			this.sodcheck.clash = false;
			this.sodcheck.valid = false;
			this.sodcheck.userAsText = this.autocompleteDisplaySelectedUsername(user);
			this.api.sodCheck(user.Id, role).then(dataList => {								 
                this.selectedRoleList=[...this.selectedRoles];
				this.sodcheck.loading = false;
				 const items = Object.keys(dataList)
                      .filter(key => !isNaN(Number(key)))
                          .map(key => dataList[key]);
				this.sodcheckReponse=items;
				
			}, e => {
				alert('Sorry, something went wrong, please try again');
				this.sodcheck.loading = false;
			});
		}
	}


	public autocompleteDisplaySelectedRole(option: SystemRoleEntity) {
		if (!option) {
			return '';
		}	
		return option.System.Name + ' - ' + (option.MappedName ? option.MappedName : '') + ' (' + option.Name + ')';
	}

	public autocompleteDisplaySelectedUsername(option: SORUserEntity) {	
		if (!option) {
			return '';
		}	
		return option.FirstName + ' ' + option.LastName + ' (' + option.Login + ')';
	}

	selectedRolesChange(event:any){
		console.log(this.selectedRoles);
	   const index=this.selectedRoles.findIndex(x=>x.Id==event.Id);
		if(index>=0){
			this.selectedRoles.splice(index,1);
		}
		else
		{
			this.selectedRoles.push(event);
			
		}
	}
	geSelectedRoleName(RoleId:number){		
		const roleName=this.selectedRoleList.find(item=>item.Id==RoleId);
		return roleName? roleName.System.Name+' - '+roleName.MappedName+' ('+roleName.Name+')':'';
	}
	
	 activeCount(status: boolean):number{
        return this.sodcheckReponse.filter(item=>item.Clash==status).length;
	}

	sodcheck_Clear(){
		this.autocompleterUsers.formControl.setValue('');
		this.autocompleterUsers.formControl.reset('');
		this.autocompleterRoles.formControl.setValue('');
		this.autocompleterRoles.formControl.reset('');
		this.selectedRoles=[];
		this.sodcheckReponse=[];
	}
}
